import type { BatchItem } from '@api/hooks/useBatch.ts';
import { useBankProfile } from '@contexts/BankProfileContext.tsx';
import { type ColumnProps, Table } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';
import { Capability } from 'types/roles.ts';

import { HeaderRenderers } from './HeaderRenderers.tsx';

interface CollapsibleHeaderProps {
	item: BatchItem;
	isLoading: boolean;
	isDeleteDisabled: boolean;
}

export const CollapsibleHeader = ({
	item,
	isLoading,
	isDeleteDisabled,
}: CollapsibleHeaderProps) => {
	const { t } = useTranslation('', { keyPrefix: 'payments.batch.table' });
	const { hasCapability } = useBankProfile();
	const canDeletePayment = hasCapability(Capability.DELETE_PAYMENT);

	const columns: ColumnProps[] = [
		{
			label: t('file'),
			key: 'file',
			align: 'left',
		},
		{
			label: t('uploaded'),
			key: 'uploaded',
			align: 'left',
		},
		{
			label: t('operationsCount'),
			key: 'operations',
			align: 'left',
		},
		{
			label: t('status'),
			key: 'status',
			align: 'left',
		},
		{
			label: t('totalAmount'),
			key: 'amount',
			align: 'right',
		},
		...(canDeletePayment
			? [
					{
						label: '',
						key: 'delete',
						align: 'right',
						width: '50px',
					} as ColumnProps,
				]
			: []),
	];

	return (
		<Table
			columns={columns}
			getRowClassName={() => 'cursor-default'}
			isLoading={isLoading}
			renders={HeaderRenderers(t, isDeleteDisabled)}
			rows={item ? [item] : []}
		/>
	);
};
